import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Form, Link } from 'react-bootstrap';
import * as upsellActions from '../../upsell/actions';
import { submission as utilSubmission } from '../../utils';
import QuoteBlock from '../../routes/FormResults/QuoteBlock';
import { Loading, DialogBox } from '../../components/shared';
import BinderDialogBox from './BinderDialogBox';
import { updateWorkflowBinder }  from '../../submissions/actions'
import { validateDate } from '../../utils/checkBindDate.js';
import moment from 'moment';
import {saveByteArray_getUrl,base64ToArrayBuffer} from '../../utils/utilities';

class OCPBinder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isBinded: !!this.props.submission.isBinded ? this.props.submission.isBinded : false,
            showUploadModal : this.props.isDashboardBinder ? true : false,
            submission : this.props.submission,
            isPreview : false,
            loading : true,
            showAgencyAlert: !this.props.isActiveBrokerage            
        };

        this.handleClick = this.handleClick.bind(this);
        this.hideUploadModal = this.hideUploadModal.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handlepdf=this.handlepdf.bind(this);
        this.handleHidePdf=this.handleHidePdf.bind(this);
        this.hideAgencyAlert = this.hideAgencyAlert.bind(this);
        
    }

    componentDidMount() {
        const { submission } = this.props;
        let props = utilSubmission.getRatingProperties(this.props.submission);
    }

    handleClick() {
       this.setState({
           ...this.state,
           showUploadModal : true
       })
    }

    hideUploadModal() { 
        this.setState ({
            showUploadModal : false,
        })
        if(this.props.isDashboardBinder){
            this.props.handleOcpBind('')
        }
        
    }
    handlepdf(isPreview){
        this.setState({
            isPreview,            
        })
    }

    handleHidePdf(){
        this.setState({
            isPreview:false,            
        })
    }

    hideAgencyAlert() {
        this.setState({
            showAgencyAlert: false,
        })
        this.props.handleOcpBind('')
    }

    handleUpload(value) {
        let updatedSubmission = this.state.submission;
        updatedSubmission.isBinded = true;
        this.setState({
            ...this.state,
            showUploadModal : value.data && value.data.errorMessage,
            isBinded: true,
            submission : updatedSubmission
        })
        if(!this.props.isDashboardBinder){
        this.props.handleBindRequest(this.state.submission);
        }
        else{
            if(value.data && value.data.errorMessage) {
            this.props.handleOcpBind('', true)
            } else {
            this.props.handleOcpBind('')
            }
        }
        window.scrollTo(0,0);
    }

    handleSave(value) {
        let updatedSubmission = this.state.submission;
        updatedSubmission.binderData = !!value && !!value.objSubmission ? value.objSubmission.binderData : {};
        updatedSubmission.isBinderSaved = true;
        this.setState({
            showUploadModal : value && value.errorMessage,
            submission: updatedSubmission
        });
        if(!this.props.isDashboardBinder){
        this.props.handleBindSaveRequest(this.state.submission);
        }
        else{
            if(value && value.errorMessage) {
            this.props.handleOcpBind('', true)
            } else {
            this.props.handleOcpBind('')
            }
        }
        window.scrollTo(0,0);
    }

    render() {
        let buttonProps = {
            disabled: this.state.isBinded || !this.props.isActiveBrokerage
        };
        const data=this.props.PDFdata;
        var url;
        if(data) {
            data.split(',').forEach((file) => {
                const fileArray = file.split('_');
                url = saveByteArray_getUrl(base64ToArrayBuffer(fileArray[0]), fileArray[1]);
            })
        }
        const getSaved = this.props.submission.binderData ?
            validateDate(this.props.submission.binderData.bindInitiated): null;
        const timer = getSaved ? `${getSaved} day(s) left to submit the binder with effective date ${moment(this.props.submission.binderData.bindeffectiveDate).format('MM-DD-YYYY')}!`: '';
        let buttonLabel = getSaved ? 'Resume Binder' : 'Start Binder';
        buttonProps.bsStyle = 'default';
        const mainTitle = "This Owner's Contractors Protective submission qualifies for automatic binding!"
        const subTitle = "OCP Binder for"
        const title = subTitle.concat(' ', this.state.submission.primaryInsuredName)
        let theme = 'prominent';
        return (!this.props.isActiveBrokerage && this.props.isDashboardBinder ? (<DialogBox
            title={'The submission is disabled as it belongs to inactive broker company'}
            show={this.state.showAgencyAlert}
            onHide={this.hideAgencyAlert}
        >
        </DialogBox>) :
        <div>
            <DialogBox
            title={title}
            custom_class="OCP Binder"
            subtitle="Submitting will lock the submission and prevent revisions. You can save this bind order by clicking Save for Later below, which will hold the order for 5 business days with the given effective date and attachments. After 5 business days the information will be removed and the binder must be started again to submit."
            show={this.state.showUploadModal}
            onHide={this.hideUploadModal}
            isPreview={this.state.isPreview}
            url={url}
            handleHidePdf={this.handleHidePdf}
            pdfStatus={this.props.pdfStatus}
            >
            <BinderDialogBox
            submission={this.props.submission}
            user={this.props.user}
            underwriter={this.props.underwriter}
            isUnderwriter={this.props.isUnderwriter}
            getSaved={getSaved}
            handleUpload={this.handleUpload}
            handleSave={this.handleSave}
            handlepdf={this.handlepdf}
            />
            </DialogBox>
            {!this.props.isDashboardBinder &&
            <div className="row">
                <div className="col-xs-8 mt">
                    <div className={classNames('upsell-component', theme)}>
                        <div className="card card-primary center">
                            <section className="pb-x2 pl-x2 pr-x2">
                                <div className="h3">
                                    {mainTitle}
                                </div>
                                <div className="row" style={{maxWidth: "510px", marginLeft:"0px"}}>
                                {/* <div className="col-md-3" > */}
                                <Button
                                    type="submit"
                                    id="upsellSubmitButton"
                                    {...buttonProps}
                                    className="mt"
                                    onClick={this.handleClick}
                                >
                                    {buttonLabel}
                                </Button>
                                {/* </div> */}
                                {getSaved && <p className={classNames("mt", "p")}>{timer}</p>}
                                </div>
                                
                            </section>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
        );
    }
}

const mapStateToProps= (store) => {
    return {
        PDFdata : store.app.PDFdata,
        pdfStatus: store.app.pdfStatus,
    }
}
export default connect(mapStateToProps) (OCPBinder);

